// removed by extract-text-webpack-plugin
module.exports = {"userHeader":"_1w_X5W5wJkOYV01nMPk6Ot","localTime":"_1fPxNXvmU6Nyj5-Ngpu7Ct","mapContainer":"_3Yi37-oREbcwEbljAmQOiR","userHasMap":"_2M7Tj2YoQmSM2bABnO_HNa","useDarkTheme":"_1B1PFHWxLiOu3p0fp0clKo"};


//////////////////
// WEBPACK FOOTER
// ./components/Customers/presentational/UserCard.module.css
// module id = 781
// module chunks = 1